<template>
  <div class="contents contents--pt">
    <class-notification />
    <class-favorite
      :key="classFavoriteKey"
      @modalClass="openModalClass"
      @reloadModal="reloadFavoriteModalKey"
    />
    <class-instructor
      :key="ClassInstructorKey"
      @modalInstructor="openModalIns"
      @reloadModalIns="reloadInsModalKey"
    />
    <class-melontv
      :key="classMelonTVKey"
    />
    <modal-melon-t-v
      @reloadmelon="reloadKey"
    />
    <class-favorite-list
      :key="classFavoriteModalKey"
      :is-open="isFavoriteList"
      @close="closeModal"
      @changeCategory="changeCategory($event)"
    />
    <class-instructor-list
      :key="ClassInstructorModalKey"
      :is-open="isInstructorModal"
      @close="closeModalIns"
      @changeIntructor="changeInstructor($event)"
    />
  </div>
</template>

<script>
import ClassNotification from '@/views/pages/class/components/ClassNotification'
import ClassFavorite from '@/views/pages/class/components/ClassFavorite'
import ClassInstructor from '@/views/pages/class/components/ClassInstructor'
import ClassMelontv from '@/views/pages/class/components/ClassMelontv'
import ModalMelonTV from '@/views/components/modals/ModalMelonTV'
import ClassFavoriteList from './components/ClassFavoriteModal/ClassFavoriteList.vue'
import ClassInstructorList from './components/ClassInstructorModal/ClassInstructorList.vue'
import favoriteService from '@/services/favoriteService'

export default {
  name: 'Class',
  components: { ClassNotification, ClassFavorite, ClassInstructor, ClassMelontv, ModalMelonTV, ClassFavoriteList, ClassInstructorList },
  data() {
    return {
      classFavoriteKey: 0,
      classFavoriteModalKey: 100,
      ClassInstructorModalKey: 1000,
      ClassInstructorKey: 10000,
      isFavoriteList: false,
      isInstructorModal: false,
      classMelonTVKey: 2000
    }
  },
  methods:
  {
    // Class category favorite
    reloadFavoriteModalKey() {
      this.classFavoriteModalKey++
    },
    openModalClass() {
      this.isFavoriteList = true
    },
    closeModal() {
      this.isFavoriteList = false
    },
    async changeCategory(id) {
      this.$store.dispatch('loading/updateLoading', true)
      await favoriteService.addCategoryFavorite(id)
      this.$store.dispatch('loading/updateLoading', false)
      this.classFavoriteKey++
    },
    // Instructor favorite
    openModalIns() {
      this.isInstructorModal = true
    },
    closeModalIns() {
      this.isInstructorModal = false
    },
    reloadInsModalKey() {
      this.ClassInstructorModalKey++
    },
    async changeInstructor(id) {
      this.$store.dispatch('loading/updateLoading', true)
      await favoriteService.addInstructorFavorite(id)
      this.$store.dispatch('loading/updateLoading', false)
      this.ClassInstructorKey++
    },
    reloadKey() {
      this.classMelonTVKey++
    }
  }
}
</script>
